import { AxiosInstance } from "axios"
import { DataframeData } from "../views/pages/PortfolioManagement/types"

export interface Fundamentals {
  data: DataframeData
  available_sources: string[]
}

export interface FundamentalsMetricsResponse {
  metrics: string[] // Legacy field
  metrics_by_periodicity?: {
    Q: string[]
    FY: string[]
    CY: string[]
    M: string[]
    H: string[]
  }
}

export type FundamentalsPeriodicity = "Q" | "FY" | "CY" | "M" | "H"

export interface IFundamentalsApi {
  getMetrics: (company_id: number) => Promise<FundamentalsMetricsResponse>
  getDisplayData: (company_id: number) => Promise<Fundamentals>
}

/**
 * Api routes for /api/v1/fundamentals/
 */
const fundamentalsApi = (axiosClient: AxiosInstance): IFundamentalsApi => ({
  /**
   * GET /api/v1/fundamentals/metrics/?company_id=
   */
  getMetrics: async (company_id: number) => {
    const { data } = await axiosClient.get<FundamentalsMetricsResponse>(`/fundamentals/metrics/`, {
      params: { company_id },
    })
    return data
  },

  /**
   * GET /api/v1/fundamentals/display-data/?company_id=
   */
  getDisplayData: async (company_id: number) => {
    const { data } = await axiosClient.get<Fundamentals>(`/fundamentals/display-data/`, {
      params: { company_id },
    })
    return data
  },
})

export default fundamentalsApi
